import { render, staticRenderFns } from "./addNotification.vue?vue&type=template&id=d07dd7d6&"
import script from "./addNotification.vue?vue&type=script&lang=js&"
export * from "./addNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports